import React from 'react';
import ElementDataSection from 'components/common/element-data/ElementDataSection';
import Thumbnail from 'components/common/element-data/parts/Thumbnail';
import { ElementMetadataSectionName, IElementDataSectionPreviewImage } from 'components/common/element-data/types';
import { getSectionElementMetadataSettings } from 'components/common/element-data/functions';

export default function PreviewImageSection(props: IElementDataSectionPreviewImage) {
    const { settings, ...element } = props;
    const sectionKey: ElementMetadataSectionName = 'preview_image';
    const { sectionMetadataOrder } = getSectionElementMetadataSettings(settings, sectionKey);

    return (
        <ElementDataSection order={sectionMetadataOrder}>
            <Thumbnail {...element} settings={settings} />
        </ElementDataSection>
    );
}
